import styled from "styled-components";

import { VIEW_PADDING_VALUE } from "../../views/View.styles";

export const StyledEmphasisedBackground = styled.div`
    padding: ${VIEW_PADDING_VALUE}px;
    background-color: ${props => props.theme.C_BG_hiddingpanel_new};
    border-radius: 30px;
    width: 100%;
    height: fit-content;
    container-type: inline-size;
`;